import { IExameResultado } from './iexame-resultado';

export interface IExameResultadoState {
    resultado: IExameResultado,
    resultados: IExameResultado[],
    error?: any,
    guid?: string | number
}
